/* Así funciona · Estante Organizador sobre Lavadora (604373), blanco
   Todo es la foto real del estante sobre la lavadora (pared de baldosa en rombos). Arranca con 3 cosas encima de la
   lavadora (el detergente, las toallas y los pañuelos REALES de la foto, recortados) y las repisas con su espacio libre
   (lo de detrás rehecho con la misma pared y las mismas varillas, sin IA). La clienta arrastra (o toca) cada cosa y
   sube a su lugar real en el estante; al llegar se funde la foto real de ese rincón (queda la foto exacta).
   Ficha: repisas sobre la lavadora, ganchos laterales, color blanco. Piezas: funciona/<handle>/hacer.py */
NHF.escena('estante-organizador-sobre-lavadora', function (E) {
  const D = /*DATOS*/{"piezas":[{"id":"detergente","nombre":"Detergente","caja":[667,102,56,210],"src":"fn-estante-organizador-sobre-lavadora-pieza-detergente.webp","parche":"fn-estante-organizador-sobre-lavadora-parche-detergente.webp","parche_caja":[657,91,77,225],"abajo":[694.5,308]},{"id":"toallas","nombre":"Toallas","caja":[599,425,208,77],"src":"fn-estante-organizador-sobre-lavadora-pieza-toallas.webp","parche":"fn-estante-organizador-sobre-lavadora-parche-toallas.webp","parche_caja":[587,416,228,89],"abajo":[708.7,496]},{"id":"panuelos","nombre":"Pañuelos","caja":[725,635,90,68],"src":"fn-estante-organizador-sobre-lavadora-pieza-panuelos.webp","parche":"fn-estante-organizador-sobre-lavadora-parche-panuelos.webp","parche_caja":[714,625,111,88],"abajo":[769.8,699]}],"W":1520,"H":1520,"base":"fn-estante-organizador-sobre-lavadora-base.webp","base_caja":[370,68,740,872],"vista":[380,70,720,860],"tapa_y":797}/*FIN*/;
  // dónde arrancan (encima de la tapa de la lavadora): [centro x, apoyo y] en px de la foto; el orden = de atrás a adelante
  const INICIO = { toallas: [624, 787], detergente: [786, 795], panuelos: [604, 797] };
  const Z = { toallas: 20, detergente: 22, panuelos: 24 };
  const NOMBRE = { detergente: 'el detergente', toallas: 'las toallas', panuelos: 'los pañuelos' };
  const REPISA = { detergente: 'la repisa de arriba', toallas: 'la del medio', panuelos: 'la de abajo' };
  const movil = window.innerWidth < 760;
  const S = E.lienzo({ w: D.W, h: D.H, vista: D.vista, vistaMovil: [440, 75, 620, 820] });
  E.titulo('La lavadora libre, [todo a la mano].', 'Arrastra cada cosa de encima de la lavadora a su repisa (o tócala).');
  E.conSonido();
  S.cargando(true);
  S.img(D.base, D.base_caja, { z: 1, alt: 'Estante blanco de 3 repisas sobre la lavadora, con ganchos a un lado' });
  E.cargar([D.base].concat(D.piezas.map(p => p.src), D.piezas.map(p => p.parche))).then(() => S.cargando(false));

  // estilos propios (solo dentro de esta escena)
  const st = document.createElement('style');
  st.textContent = '[data-nhf-handle="estante-organizador-sobre-lavadora"] .eol-agarre{position:absolute;pointer-events:auto;cursor:grab;border-radius:24px;touch-action:none}' +
    '[data-nhf-handle="estante-organizador-sobre-lavadora"] .is-arrastrando .eol-agarre{cursor:grabbing}';
  E.raiz.appendChild(st);

  E.pasos(D.piezas.map(p => 'Sube ' + NOMBRE[p.id] + ' a ' + REPISA[p.id]));
  E.paso(0);
  const lect = E.lectura({ etiqueta: 'En el estante' }); lect.poner('0', 'de 3');
  const bAuto = E.boton('Ordénalo por mí', () => autoOrdenar(), { icono: 'toca' });
  E.nota('Tres repisas sobre la lavadora y ganchos a un lado para colgar la toalla.');

  let puestas = 0, ocupado = false;
  const piezas = D.piezas.map(p => {
    const [x, y, w, h] = p.caja;
    const parche = S.img(p.parche, p.parche_caja, { z: 3, opacidad: 0 });
    parche.style.transition = 'opacity .35s ease';
    // sombra de apoyo sobre la tapa de la lavadora (se oscurece la tapa real, no se dibuja nada encima del producto)
    const ini = INICIO[p.id];
    const dx0 = ini[0] - p.abajo[0], dy0 = ini[1] - p.abajo[1];
    const ancho = w * 0.92;
    const sombra = S.div([ini[0] - ancho / 2, ini[1] - 7, ancho, 13], { z: Z[p.id] - 1 });
    sombra.style.cssText += ';border-radius:50%;background:radial-gradient(closest-side,rgba(60,45,30,.42),rgba(60,45,30,.18) 55%,rgba(60,45,30,0));mix-blend-mode:multiply;transition:opacity .3s ease';
    const g = S.grupo(p.caja, { z: Z[p.id] });
    S.img(p.src, p.caja, { en: g, alt: p.nombre });
    g.style.pointerEvents = 'none';
    g.style.filter = 'drop-shadow(0 4px 5px rgba(60,45,30,.18))';
    // zona para agarrarlo: el objeto con margen (>= 44 px en el celular)
    const k = movil ? 0.58 : 1;
    const mx = Math.max(4, (48 / k - w) / 2), my = Math.max(4, (48 / k - h) / 2);
    const ag = E.el('span', 'eol-agarre');
    ag.style.cssText = 'left:' + (-mx) + 'px;top:' + (-my) + 'px;width:' + (w + 2 * mx) + 'px;height:' + (h + 2 * my) + 'px';
    g.appendChild(ag);
    const P = { p, g, ag, parche, sombra, dx0, dy0, puesta: false, cx: x + w / 2, cy: y + h / 2 };
    P.arr = E.arrastrable(g, {
      etiqueta: p.nombre + ': súbelo a su repisa',
      destinos: [{ x: P.cx, y: P.cy, r: 210, id: p.id }],
      alEmpezar() {
        if (P.puesta || ocupado) return;
        sombra.style.opacity = 0;
        g.style.filter = 'drop-shadow(0 22px 18px rgba(50,38,25,.28))';
        g.style.zIndex = 60;
        E.sonido.tono(700, .04, .02);
      },
      alSoltar(dest, pos) {
        if (P.puesta) return;
        const movio = Math.hypot(pos.dx - P.dx0, pos.dy - P.dy0);
        if (dest || movio < 12) poner(P);
        else volver(P);
      },
      alTeclado() { poner(P); }
    });
    g.style.pointerEvents = 'none';
    P.arr.mover(dx0, dy0);
    return P;
  });

  // movimiento en arco (sube un poco, viaja y se asienta en su lugar real)
  function viaje(P, x1, y1, ms) {
    const a = P.arr.pos(), x0 = a.dx, y0 = a.dy;
    const alto = Math.min(90, 30 + Math.abs(y1 - y0) * 0.12);
    return E.animarP(ms, k => {
      const x = x0 + (x1 - x0) * k;
      const y = y0 + (y1 - y0) * k - Math.sin(Math.PI * k) * alto;
      P.arr.mover(x, y);
    });
  }
  async function poner(P) {
    if (P.puesta) return;
    if (ocupado) { volver(P); return; }
    P.puesta = true; ocupado = true;
    P.ag.style.pointerEvents = 'none';
    P.sombra.style.opacity = 0;
    P.g.style.zIndex = 60;
    P.g.style.filter = 'drop-shadow(0 16px 14px rgba(50,38,25,.22))';
    await viaje(P, 0, -5, 620);
    await E.animarP(160, k => P.arr.mover(0, -5 + 5 * k));
    P.g.style.transition = 'filter .25s ease'; P.g.style.filter = 'none';
    // al asentarse queda la foto real de ese rincón (con su sombra real)
    P.parche.style.opacity = 1;
    E.sonido.tono(1900, .07, .03); setTimeout(() => E.sonido.tono(2500, .06, .02), 70); E.vibrar(10);
    await E.esperar(360);
    P.g.style.opacity = 0; P.g.style.zIndex = 4;
    puestas++;
    lect.poner(String(puestas), 'de 3');
    E.paso(puestas);
    ocupado = false;
    if (puestas >= 3) {
      bAuto.hidden = true; S.pista(null);
      E.listo('Así queda: la lavadora libre y cada cosa en su repisa, a la mano.', reiniciar);
    } else {
      const sig = piezas.find(q => !q.puesta);
      S.pista('Ahora ' + NOMBRE[sig.p.id], 'mano');
    }
  }
  function volver(P) {
    P.g.style.filter = 'drop-shadow(0 4px 5px rgba(60,45,30,.18))';
    viaje(P, P.dx0, P.dy0, 420).then(() => { P.sombra.style.opacity = 1; P.g.style.zIndex = Z[P.p.id]; });
  }
  async function autoOrdenar() {
    bAuto.hidden = true;
    for (const id of ['detergente', 'toallas', 'panuelos']) {
      const P = piezas.find(q => q.p.id === id);
      while (ocupado) await E.esperar(100);   // si la clienta está moviendo una, se espera
      if (!P.puesta) { await poner(P); await E.esperar(180); }
    }
  }
  function reiniciar() {
    E.noListo(); puestas = 0; ocupado = false;
    piezas.forEach(P => {
      P.puesta = false; P.parche.style.opacity = 0;
      P.g.style.transition = 'none'; P.g.style.opacity = 1; P.g.style.zIndex = Z[P.p.id];
      P.g.style.filter = 'drop-shadow(0 4px 5px rgba(60,45,30,.18))';
      P.ag.style.pointerEvents = 'auto';
      P.arr.mover(P.dx0, P.dy0, 500);
      P.sombra.style.opacity = 1;
    });
    lect.poner('0', 'de 3'); bAuto.hidden = false; E.paso(0);
    S.pista('Arrastra cada cosa a su repisa', 'mano');
  }
  S.pista('Arrastra cada cosa a su repisa', 'mano');
});
